<template>
  <resume-item v-if="extra.total_amount">
    <template v-slot:label_sx>{{ get_extra_charge(extra.charge).name }}</template>
    <template v-slot:icon>
      <vb-icon
        v-if="get_extra_charge(extra.charge).tooltip"
        class="ml-1"
        :name="'info'"
        :color="sass('gray-500')"
        :size="13"
        v-b-popover.hover.top="get_extra_charge(extra.charge).tooltip"
      />
    </template>
    <template v-slot:label_dx>{{ '€ ' + round_up(extra.total_amount) }}</template>
  </resume-item>
</template>

<script>
import { round_up } from '@bookingv3/utilities'
import {get_extra_charge} from '@bookingv3/resources'
import ResumeItem from "@bookingv3/components/blocks/resume/resume-item"

export default {
  name: 'resume-extra-item',

  components: {
    'resume-item': ResumeItem
  },

  props: {
    extra: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.round_up = round_up
    this.get_extra_charge = get_extra_charge
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>